import { faArrowUpRightFromSquare } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const link = "https://support.skydio.com/hc/articles/33456277678235";
export const SsoHelpLink = () => (
  <a href={link} target="_blank" rel="noreferrer">
    Learn more about configuring SSO <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
  </a>
);
